import { Injectable } from '@angular/core';
import { JourneyTrack } from "./journey-track";
import { TrackTypes } from "./model/track-types";
import { BasicTrack } from "./cadastro-investidor/basic-track";
import { ContaIonTrack } from "./conta-ion/conta-ion-track";
import { ContaIonPersonalTrack } from "./conta-ion/conta-ion-personal-track";
import { ContaIonProfessionalTrack } from "./conta-ion/conta-ion-professional-track";
import { ContaIonMaritalTrack } from "./conta-ion/conta-ion-marital-track";
import { ContaIonIncomeTrack } from "./conta-ion/conta-ion-income";
import { ContaIonAddressTrack } from "./conta-ion/conta-ion-address-track";
import { ExpTrack } from "./conta-ion/exp-track";
import { CacheService } from "../../comunicator-native/cache/v2/cache.service";
import { BasicAddressTrack } from "./cadastro-investidor/basic-address-track";
import { BasicIncomeTrack } from "./cadastro-investidor/basic-income-track";
import { BasicMaritalTrack } from "./cadastro-investidor/basic-marital-track";
import { BasicPersonalTrack } from "./cadastro-investidor/basic-personal-track";
import { BasicProfessionalTrack } from "./cadastro-investidor/basic-professional-track";
import { DomainFactoryService } from "../../domains/domain-factory-service";
import { LogService } from "../../log/log.service";
import { TokenService } from "../../token/token.service";
import { UpdateRegistrationTrack } from './atualizacao-cadastral/update-registration-track';
import { UpdateProfileTrack } from './atualizacao-cadastral/update-profile.track';
import { UpdateMaritalTrack } from './atualizacao-cadastral/update-marital.track';
import { UpdateProfessionalTrack } from './atualizacao-cadastral/update-professional.track';
import { UpdateIncomeTrack } from './atualizacao-cadastral/update-income.track';
import { UpdateRegistrationFactoryService } from '../../update-registration/update-registration-factory-service';
import { UserRegistrationFactoryService } from '../../user-registration/user-registration-factory-service';
import { UpdateAddressTrack } from './atualizacao-cadastral/update-address-track';
import { BasicTrackV2 } from './cadastro-investidor-v2/basic-v2-track';
import { Typedata } from '../../../../shared/model/type-data';
import { BasicPersonalTrackV2 } from './cadastro-investidor-v2/basic-personal-v2-track';
import { BasicProfileTrackV2 } from './cadastro-investidor-v2/basic-profile-v2-track';
import { BasicAddressTrackV2 } from './cadastro-investidor-v2/basic-address-v2-track';
import { BasicMaritalTrackV2 } from './cadastro-investidor-v2/basic-marital-v2-track';
import { BasicIncomeTrackV2 } from './cadastro-investidor-v2/basic-income-v2-track';
import { BasicProfessionalTrackV2 } from './cadastro-investidor-v2/basic-professional-v2-track';
import { NavController, Platform } from '@ionic/angular';
import { FirstAccessTrack } from './primeiro-acesso/first-access-track';
import { UpdateIncomeContaIonTrack } from './atualizacao-cadastral/update-income-conta-ion.track';

@Injectable({
  providedIn: 'root'
})
export class JourneyTrackFactoryService {

  constructor(
    private cacheNativeService: CacheService,
    public domainFactory: DomainFactoryService,
    private router: NavController,
    private logService: LogService,
    private tokenService: TokenService,
    private updateRegistrationFactory: UpdateRegistrationFactoryService,
    private userRegistrationFactoryService: UserRegistrationFactoryService,
    private platform: Platform) { }

  create(trackType: TrackTypes, typeData?: any): Promise<JourneyTrack> {

    if (typeData) {
      switch (typeData) {
        case Typedata["marital-status"]:
          return Promise.resolve(new BasicMaritalTrack(this.cacheNativeService));
        case Typedata.address:
          return Promise.resolve(new BasicAddressTrack(this.cacheNativeService));
        case Typedata.income:
          return Promise.resolve(new BasicIncomeTrack(this.cacheNativeService));
        case Typedata.personal:
          return Promise.resolve(new BasicPersonalTrack(this.cacheNativeService));
        case Typedata.professional:
          return Promise.resolve(new BasicProfessionalTrack(this.cacheNativeService));
      }
    } else {
      switch (trackType) {
        case TrackTypes.BASIC:
          return Promise.resolve(new BasicTrack(this.cacheNativeService));
        case TrackTypes.BASIC_V2:
          return Promise.resolve(new BasicTrackV2(this.userRegistrationFactoryService, this.router));
        case TrackTypes.CONTA_ION:
          return Promise.resolve(new ContaIonTrack(this.cacheNativeService));
        case TrackTypes.CONTA_ION_PERSONAL:
          return Promise.resolve(new ContaIonPersonalTrack(this.cacheNativeService, this.domainFactory, this.logService, this.tokenService, this.platform));
        case TrackTypes.CONTA_ION_PROFESSIONAL:
          return Promise.resolve(new ContaIonProfessionalTrack(this.cacheNativeService, this.platform));
        case TrackTypes.CONTA_ION_MARITAL:
          return Promise.resolve(new ContaIonMaritalTrack(this.cacheNativeService, this.platform));
        case TrackTypes.CONTA_ION_INCOME:
          return Promise.resolve(new ContaIonIncomeTrack(this.cacheNativeService, this.platform));
        case TrackTypes.CONTA_ION_ADDRESS:
          return Promise.resolve(new ContaIonAddressTrack(this.cacheNativeService, this.platform));
        case TrackTypes.EXPERIMENTATION:
          return Promise.resolve(new ExpTrack());
        case TrackTypes.BASIC_PERSONAL_V2:
          return Promise.resolve(new BasicPersonalTrackV2());
        case TrackTypes.BASIC_PROFILE_V2:
          return Promise.resolve(new BasicProfileTrackV2());
        case TrackTypes.BASIC_ADDRESS_V2:
          return Promise.resolve(new BasicAddressTrackV2());
        case TrackTypes.BASIC_MARITAL_V2:
          return Promise.resolve(new BasicMaritalTrackV2());
        case TrackTypes.BASIC_INCOME_V2:
          return Promise.resolve(new BasicIncomeTrackV2());
        case TrackTypes.BASIC_PROFESSIONAL_V2:
          return Promise.resolve(new BasicProfessionalTrackV2());
        case TrackTypes.UPDATE_REGISTRATION:
          return Promise.resolve(new UpdateRegistrationTrack(this.updateRegistrationFactory));
        case TrackTypes.UPDATE_PROFILE:
          return Promise.resolve(new UpdateProfileTrack());
        case TrackTypes.UPDATE_ADDRESS:
          return Promise.resolve(new UpdateAddressTrack());
        case TrackTypes.UPDATE_MARITAL:
          return Promise.resolve(new UpdateMaritalTrack());
        case TrackTypes.UPDATE_PROFESSIONAL:
          return Promise.resolve(new UpdateProfessionalTrack());
        case TrackTypes.UPDATE_INCOME:
          return Promise.resolve(new UpdateIncomeTrack());
        case TrackTypes.UPDATE_INCOME_CONTA_ION:
          return Promise.resolve(new UpdateIncomeContaIonTrack());
        case TrackTypes.FIRST_ACCESS:
          return Promise.resolve(new FirstAccessTrack());
      }
    }
  }
}
